import { Component, OnInit, ViewEncapsulation, DoCheck } from '@angular/core';
import { query, trigger, transition, style, animate } from '@angular/animations';
import { SharedService } from '../shared/shared.service';
import { registerLocaleData } from '@angular/common';
import localeBr from '@angular/common/locales/pt';
import { AppEventDispatcher } from '../utils/AppEventDispatcher';
import { EventTypes } from '../shared/EventTypes';
import { Auth } from '../autentication/Auth';
import { OAuthTokenService } from '../autentication/o-auth-token.service';
import { AutenticationService } from '../autentication/autentication.service';

@Component({
	selector: 'app-master',
	templateUrl: './master.component.html',
	styleUrls: ['./master.component.styl'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('MasterAnimation', [
			transition('* <=> *', [
				query(':enter',
					style({
						position: 'fixed',
						top: 0,
						width: '100%',
						height: '100%',
						transform: 'translateX(100%)',
						backgroundColor: '#f6f6f6',
						zIndex: 1000
					}),
					{optional: true}),

					query(':enter',
						animate('0.6s 0.2s ease-out',
							style({
								transform: 'translateX(0%)'
							})
						),
					{optional: true}),
			])
		])
	]
})
export class MasterComponent implements OnInit, DoCheck {
	loadingHttp = true;
	
	constructor(
		public sharedService: SharedService,
		private oAuthTokenService: OAuthTokenService,
		private autenticationService: AutenticationService
	) { }
	
	ngOnInit() {
		registerLocaleData(localeBr, 'pt-BR');
		AppEventDispatcher.dispatch(EventTypes.MENU.CHANGE, { show: true });
		const SECONDS = 350000;

		this.selectAccount();

		setInterval(() => {
			if(Auth.getInstance().getUser()){
				this.selectAccount();
			}
		}, SECONDS)
	}

	ngDoCheck(): void {
		this.loadingHttp = localStorage.getItem('loading') ? true : false;
	}

	selectAccount() {
		const token = sessionStorage.getItem('_OmniBearerRefreshV2');
		this.oAuthTokenService.selectAccount(token).subscribe(() => {
			if (!sessionStorage.getItem('_OmniSummarizedSent')) {
				this.autenticationService.sendSummarizedEvent();
				sessionStorage.setItem('_OmniSummarizedSent', 'true');
			}
		});
	}


}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/master.component.ts